import * as actionTypes from './actionTypes'

import organizationAxios from '../../axios/organization'
import { getListingIndex } from '../../helpers/utils'
import { enqueueSnackbar } from './alert'
import { saveFileFromResponse } from '../../helpers/utils'
import dropDownAxios from '../../axios/appraisalDropdownOptions'

export const fetchOrg = filterOptions => {
  return dispatch => {
    const params = {
      ...filterOptions,
      page: filterOptions ? filterOptions.page : 1,
      perPage: filterOptions ? filterOptions.perPage : 10
    }

    dispatch(fetchOrgStart())

    organizationAxios
      .get('', { params })
      .then(response => {
        if (response.status === 200 && response.data.success) {
          const { current_page, from, last_page, per_page, to, total, data } = response.data.data

          const pagination = {
            currentPage: current_page,
            lastPage: last_page,
            perPage: per_page,
            from,
            to,
            total
          }

          const dataWithOption = data.map((item, index) => {
            return { ...item, index: getListingIndex(index, per_page, current_page) }
          })

          dispatch(fetchOrgSuccess(pagination, dataWithOption))
        }
      })
      .catch(error => {
        dispatch(fetchOrgFailed(error))
      })
  }
}

export const fetchOrgStart = () => {
  return {
    type: actionTypes.FETCH_ORGANIZATION_START
  }
}

export const fetchOrgSuccess = (pagination, records) => {
  return {
    type: actionTypes.FETCH_ORGANIZATION_SUCCESS,
    pagination,
    records
  }
}

export const fetchOrgFailed = errorMessage => {
  return {
    type: actionTypes.FETCH_ORGANIZATION_FAILED,
    errorMessage
  }
}

export const fetchOrgById = recordId => {
  return dispatch => {
    dispatch(fetchOrgStart())
    organizationAxios
      .get(`/${recordId}`)
      .then(response => {
        if (response.status === 200) {
          dispatch(fetchOrgByIdSuccess(response.data.data))
        }
      })
      .catch(error => {
        dispatch(fetchOrgFailed(error))
      })
  }
}

export const fetchOrgByIdSuccess = recordData => {
  return {
    type: actionTypes.FETCH_ORGANIZATION_BY_ID_SUCCESS,
    recordData
  }
}

export const clearSelectedOrgRecord = () => {
  return {
    type: actionTypes.CLEAR_SELECTED_ORGANIZATION_RECORD
  }
}

export const createOrg = (recordData, page) => {
  return dispatch => {
    dispatch(createOrgStart())

    organizationAxios
      .post('', recordData)
      .then(response => {
        if (response.status === 201) {
          dispatch(
            enqueueSnackbar({
              message: 'Organization Created',
              options: {
                variant: 'success'
              }
            })
          )
          dispatch(createOrgSuccess())
          dispatch(fetchOrg(page))
        }
      })
      .catch(error => {
        switch (error.response.status) {
          case 400:
            dispatch(
              enqueueSnackbar({
                message: 'Invalid Organization field',
                options: {
                  variant: 'error',
                  data: error.response.data.data
                }
              })
            )
            break

          default:
            dispatch(
              enqueueSnackbar({
                message: error.response.data.message,
                options: {
                  variant: 'error'
                }
              })
            )
            break
        }
        dispatch(createOrgFailed())
      })
  }
}

export const createOrgStart = () => {
  return {
    type: actionTypes.CREATE_ORGANIZATION_START
  }
}

export const createOrgSuccess = () => {
  return {
    type: actionTypes.CREATE_ORGANIZATION_SUCCESS
  }
}

export const createOrgFailed = () => {
  return {
    type: actionTypes.CREATE_ORGANIZATION_FAILED
  }
}

export const updateOrg = (recordId, recordData, page) => {
  return dispatch => {
    dispatch(updateOrgStart())
    organizationAxios
      .patch(`/${recordId}`, recordData)
      .then(response => {
        dispatch(
          enqueueSnackbar({
            message: 'Organization Updated',
            options: {
              key: recordId,
              variant: 'success'
            }
          })
        )
        dispatch(fetchOrg(page))
        dispatch(updateOrgSuccess())
      })
      .catch(error => {
        switch (error.response.status) {
          case 400:
            dispatch(
              enqueueSnackbar({
                message: 'Invalid Organization field',
                options: {
                  variant: 'error',
                  data: error.response.data.data
                }
              })
            )
            break

          default:
            dispatch(
              enqueueSnackbar({
                message: error.response.data.message,
                options: {
                  variant: 'error'
                }
              })
            )
            break
        }
        dispatch(updateOrgFailed())
      })
  }
}

export const updateOrgStart = () => {
  return {
    type: actionTypes.UPDATE_ORGANIZATION_START
  }
}

export const updateOrgSuccess = () => {
  return {
    type: actionTypes.UPDATE_ORGANIZATION_SUCCESS
  }
}

export const updateOrgFailed = () => {
  return {
    type: actionTypes.UPDATE_ORGANIZATION_FAILED
  }
}

export const deleteOrg = (recordId, page) => {
  return dispatch => {
    dispatch(deleteOrgStart())
    organizationAxios
      .delete(`/${recordId}`)
      .then(response => {
        dispatch(
          enqueueSnackbar({
            message: 'Organization Deleted',
            options: {
              key: recordId,
              variant: 'success'
            }
          })
        )
        dispatch(fetchOrg(page))
      })
      .catch(error => {
        dispatch(
          enqueueSnackbar({
            message: 'Delete failed',
            options: {
              variant: 'error'
            }
          })
        )
        dispatch(deleteOrgFailed())
      })
  }
}

export const deleteOrgStart = () => {
  return {
    type: actionTypes.DELETE_ORGANIZATION_START
  }
}

export const deleteOrgSuccess = message => {
  return {
    type: actionTypes.DELETE_ORGANIZATION_SUCCESS,
    message
  }
}

export const deleteOrgFailed = errorMessage => {
  return {
    type: actionTypes.DELETE_ORGANIZATION_FAILED,
    errorMessage
  }
}

export const fetchOrgLevelOptions = filter => {
  return dispatch => {
    dispatch(fetchOrgLevelOptionsStart())
    let params = null
    if (filter) {
      params = {
        ...filter
      }
    }
    organizationAxios
      .get('/orglevel/dropdown', { params })
      .then(response => {
        if (response.status === 200) {
          dispatch(fetchOrgLevelOptionsSuccess(response.data.data))
        }
      })
      .catch(error => {
        dispatch(fetchOrgLevelOptionsFailed(error))
      })
  }
}

export const fetchOrgLevelOptionsStart = () => {
  return {
    type: actionTypes.FETCH_ORGANIZATION_LEVEL_OPTIONS_START
  }
}

export const fetchOrgLevelOptionsSuccess = data => {
  return {
    type: actionTypes.FETCH_ORGANIZATION_LEVEL_OPTIONS_SUCCESS,
    data
  }
}

export const fetchOrgLevelOptionsFailed = errorMessage => {
  return {
    type: actionTypes.FETCH_ORGANIZATION_LEVEL_OPTIONS_FAILED,
    errorMessage
  }
}

export const fetchParentOptions = filter => {
  return dispatch => {
    dispatch(fetchParentOptionsStart())
    let params = null
    if (filter) {
      params = {
        ...filter
      }
    }
    organizationAxios
      .get('/dropdown', { params })
      .then(response => {
        if (response.status === 200) {
          dispatch(fetchParentOptionsSuccess(response.data.data))
        }
      })
      .catch(error => {
        dispatch(fetchParentOptionsFailed(error))
      })
  }
}

export const importOrg = importFile => {
  return dispatch => {
    dispatch(importOrgStart())
    let formData = new FormData()
    formData.append('file', importFile)

    organizationAxios
      .post('/import', formData)
      .then(response => {
        if (response.status === 200) {
          dispatch(importOrgSuccess(response.data))
          dispatch(
            enqueueSnackbar({
              message: 'Organization Imported',
              options: {
                variant: 'success'
              }
            })
          )
          dispatch(fetchOrg())
        }
      })
      .catch(error => {
        dispatch(
          enqueueSnackbar({
            message: 'Organization Imported Error',
            options: {
              variant: 'error',
              data: error.response.data.data
            }
          })
        )
        dispatch(importOrgFailed(error))
      })
  }
}

export const importOrgStart = () => {
  return {
    type: actionTypes.IMPORT_LEVEL_START
  }
}

export const importOrgSuccess = () => {
  return {
    type: actionTypes.IMPORT_LEVEL_SUCCESS
  }
}

export const importOrgFailed = errorMessage => {
  return {
    type: actionTypes.IMPORT_LEVEL_FAILED,
    errorMessage
  }
}

export const exportOrg = filterOptions => {
  return dispatch => {
    dispatch(exportOrgsStart())
    let params = null
    if (filterOptions) {
      params = {
        ...filterOptions
      }
    }
    organizationAxios
      .get('/export', {
        params,
        responseType: 'blob'
      })
      .then(response => {
        if (response.status === 200) {
          saveFileFromResponse(response)
          dispatch(
            enqueueSnackbar({
              message: 'Organization Exported',
              options: {
                variant: 'success'
              }
            })
          )
          dispatch(exportOrgSuccess())
        }
      })
      .catch(error => {
        switch (error.response.status) {
          case 400:
            dispatch(
              enqueueSnackbar({
                message: 'Invalid Organization field',
                options: {
                  variant: 'error',
                  data: error.response.data.data
                }
              })
            )
            break

          default:
            dispatch(
              enqueueSnackbar({
                message: error.response.data.data,
                options: {
                  variant: 'error'
                }
              })
            )
            break
        }
        dispatch(exportOrgFailed(error))
      })
  }
}

export const exportOrgsStart = () => {
  return {
    type: actionTypes.EXPORT_LEVEL_START
  }
}

export const exportOrgSuccess = () => {
  return {
    type: actionTypes.EXPORT_LEVEL_SUCCESS
  }
}

export const exportOrgFailed = errorMessage => {
  return {
    type: actionTypes.EXPORT_LEVEL_FAILED,
    errorMessage
  }
}

export const downloadOrgTemplate = filterOptions => {
  let params = null
  if (filterOptions) {
    params = filterOptions
  }
  return dispatch => {
    dispatch(downloadOrgTemplateStart())
    organizationAxios
      .get('/download', {
        responseType: 'blob',
        params
      })
      .then(response => {
        if (response.status === 200) {
          saveFileFromResponse(response)
          dispatch(
            enqueueSnackbar({
              message: 'Organization Template Downloaded',
              options: {
                variant: 'success'
              }
            })
          )
          dispatch(downloadOrgTemplateSuccess())
        }
      })
      .catch(error => {
        switch (error.response.status) {
          case 400:
            dispatch(
              enqueueSnackbar({
                message: 'Invalid Organization field',
                options: {
                  variant: 'error',
                  data: error.response.data.data
                }
              })
            )
            break

          default:
            dispatch(
              enqueueSnackbar({
                message: error.response.data.data,
                options: {
                  variant: 'error'
                }
              })
            )
            break
        }
        dispatch(downloadOrgTemplateFailed(error))
      })
  }
}

export const downloadOrgTemplateStart = () => {
  return {
    type: actionTypes.DOWNLOAD_LEVEL_TEMPLATE_START
  }
}

export const downloadOrgTemplateSuccess = () => {
  return {
    type: actionTypes.DOWNLOAD_LEVEL_TEMPLATE_SUCCESS
  }
}

export const downloadOrgTemplateFailed = errorMessage => {
  return {
    type: actionTypes.DOWNLOAD_LEVEL_TEMPLATE_FAILED,
    errorMessage
  }
}

export const fetchParentOptionsStart = () => {
  return {
    type: actionTypes.FETCH_PARENT_ORGANIZATION_LEVEL_OPTIONS_START
  }
}

export const fetchParentOptionsSuccess = data => {
  return {
    type: actionTypes.FETCH_PARENT_ORGANIZATION_LEVEL_OPTIONS_SUCCESS,
    data
  }
}

export const fetchParentOptionsFailed = errorMessage => {
  return {
    type: actionTypes.FETCH_PARENT_ORGANIZATION_LEVEL_OPTIONS_FAILED,
    errorMessage
  }
}
export const fetchOrgFilterCompany = filter => {
  return dispatch => {
    dispatch(fetchOrgFilterCompanyStart())
    organizationAxios
      .get('/company/dropdown', { params: filter })
      .then(response => {
        if (response.status === 200) {
          dispatch(fetchOrgFilterCompanySuccess(response.data.data))
        }
      })
      .catch(error => {
        dispatch(fetchOrgFilterCompanyFailed(error))
      })
  }
}

export const fetchOrgFilterCompanyStart = () => {
  return {
    type: actionTypes.FETCH_ORGANIZATION_FILTER_COMPANY_START
  }
}

export const fetchOrgFilterCompanySuccess = data => {
  return {
    type: actionTypes.FETCH_ORGANIZATION_FILTER_COMPANY_SUCCESS,
    data
  }
}

export const fetchOrgFilterCompanyFailed = errorMessage => {
  return {
    type: actionTypes.FETCH_ORGANIZATION_FILTER_COMPANY_FAILED,
    errorMessage
  }
}

export const fetchOrgFilterOrg = filter => {
  return dispatch => {
    dispatch(fetchOrgFilterOrgStart())
    organizationAxios
      .get('/dropdown', { params: filter })
      .then(response => {
        if (response.status === 200) {
          dispatch(fetchOrgFilterOrgSuccess(response.data.data))
        }
      })
      .catch(error => {
        dispatch(fetchOrgFilterOrgFailed(error))
      })
  }
}

export const fetchOrgFilterOrgStart = () => {
  return {
    type: actionTypes.FETCH_ORGANIZATION_FILTER_ORGANIZATION_START
  }
}

export const fetchOrgFilterOrgSuccess = data => {
  return {
    type: actionTypes.FETCH_ORGANIZATION_FILTER_ORGANIZATION_SUCCESS,
    data
  }
}

export const fetchOrgFilterOrgFailed = errorMessage => {
  return {
    type: actionTypes.FETCH_ORGANIZATION_FILTER_ORGANIZATION_FAILED,
    errorMessage
  }
}

export const fetchOrgFilterLevel = filter => {
  return dispatch => {
    dispatch(fetchOrgFilterLevelStart())
    organizationAxios
      .get('/level/dropdown', { params: filter })
      .then(response => {
        if (response.status === 200) {
          dispatch(fetchOrgFilterLevelSuccess(response.data.data))
        }
      })
      .catch(error => {
        dispatch(fetchOrgFilterLevelFailed(error))
      })
  }
}

export const fetchOrgFilterLevelStart = () => {
  return {
    type: actionTypes.FETCH_ORGANIZATION_FILTER_LEVEL_START
  }
}

export const fetchOrgFilterLevelSuccess = data => {
  return {
    type: actionTypes.FETCH_ORGANIZATION_FILTER_LEVEL_SUCCESS,
    data
  }
}

export const fetchOrgFilterLevelFailed = errorMessage => {
  return {
    type: actionTypes.FETCH_ORGANIZATION_FILTER_LEVEL_FAILED,
    errorMessage
  }
}

export const fetchOrgChannelOptions = filter => {
  return dispatch => {
    dispatch(fetchOrgChannelOptionsStart())
    let params = null
    if (filter) {
      params = {
        ...filter
      }
    }
    dropDownAxios
      .get('/channel', { params })
      .then(response => {
        if (response.status === 200) {
          dispatch(fetchOrgChannelOptionsSuccess(response.data.data))
        }
      })
      .catch(error => {
        dispatch(fetchOrgChannelOptionsFailed(error))
      })
  }
}

export const fetchOrgChannelOptionsStart = () => {
  return {
    type: actionTypes.FETCH_ORGANIZATION_CHANNEL_OPTIONS_START
  }
}

export const fetchOrgChannelOptionsSuccess = data => {
  return {
    type: actionTypes.FETCH_ORGANIZATION_CHANNEL_OPTIONS_SUCCESS,
    data
  }
}

export const fetchOrgChannelOptionsFailed = errorMessage => {
  return {
    type: actionTypes.FETCH_ORGANIZATION_CHANNEL_OPTIONS_FAILED,
    errorMessage
  }
}
